import { motion } from "framer-motion";
import { useQuestionOverrides, resolvePhase, resolveUiLabel } from "../hooks/useQuestionOverrides";

export default function InsightScreen({ phase, lang, onContinue, continueLabel }) {
  const textOverrides = useQuestionOverrides();
  const btnLabel = resolveUiLabel(textOverrides, "continue", lang, continueLabel);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-50 bg-[#F8F6F2] flex items-center justify-center px-6"
      data-testid={`insight-${phase.id}`}
    >
      <div className="max-w-md w-full text-left">
        <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-4">— {resolvePhase(textOverrides, phase.id, "title", lang, phase.title)}</div>
        <h2 className="font-serif text-4xl sm:text-5xl leading-[1.05] text-[#383633] tracking-tight mb-6">
          {resolvePhase(textOverrides, phase.id, "insight_title", lang, phase.insight.title)}
        </h2>
        <p className="text-[#6F6B66] leading-relaxed text-base sm:text-lg mb-10">
          {resolvePhase(textOverrides, phase.id, "insight_body", lang, phase.insight.body)}
        </p>
        <button
          onClick={onContinue}
          data-testid={`insight-continue-${phase.id}`}
          className="inline-flex items-center gap-3 rounded-full bg-[#383633] text-white px-8 py-3 text-xs kt-tracking uppercase hover:bg-[#4A4238] transition"
        >
          {btnLabel}
          <span aria-hidden>→</span>
        </button>
      </div>
    </motion.div>
  );
}
